import { SiteEmployeeService, SiteEmployeeDto } from 'common/api';

export async function acceptRegistrationViaExternalOidcAPI(
  token: string
): Promise<SiteEmployeeDto> {
  return SiteEmployeeService.siteEmployeeControllerAcceptRegistrationViaExternalOidc(
    token
  );
}
